var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.shows)?_c('router-view'):_c('div',{staticClass:"jzzs"},[_c('div',[_c('van-loading',{attrs:{"type":"spinner","color":"#000"}})],1),_c('div',[_vm._v(_vm._s(_vm.tet))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }